import { useQuery } from "@apollo/client";
import { Box, Button } from "@chakra-ui/react";
import AddIcon from "@material-ui/icons/Add";
import MaterialTable, { MTableToolbar } from "material-table";
import * as React from "react";
import { useHistory } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import MaterialTableCustomSort from "../Misc/MaterialTableCustomSort";
import { COLORS_QUERY } from "../Product/hooks/useColors";
interface Props {}
const columns = [
  {
    id: "colorName",
    name: "Color Name",
  },
];
const ViewColors: React.FC<Props> = () => {
  const useCounterState = createPersistedState("sortQueryColor");
  const [sortQueryColor, setSortQueryColor] = useCounterState("colorName:asc");
  const tableRef = React.useRef(null);

  const history = useHistory();
  const { refetch } = useQuery(COLORS_QUERY, {
    skip: true,
  });

  const handleEditClick = (id: string) => {
    history.push({
      pathname: `/admin/color-form/${id}`,
    });
  };

  const handleAddClick = () => {
    history.push({
      pathname: "/admin/color-form",
    });
  };

  return (
    <>
      <Button
        colorScheme="blue"
        onClick={handleAddClick}
        className="add-btn"
        m="3"
        size="sm"
        leftIcon={<AddIcon />}
        textTransform="uppercase"
      >
        Add Colour
      </Button>
      <div>
        <MaterialTable
          tableRef={tableRef}
          title="Colours"
          columns={[
            { title: "Colour Name", field: "colorName", sorting: false },
          ]}
          actions={[
            {
              icon: "edit",
              tooltip: "Edit Color",
              onClick: (event, rowData: any) => {
                handleEditClick(rowData.id);
              },
            },
          ]}
          components={{
            Toolbar: (props) => (
              <Box display="flex" w="100%" justifyContent="space-between">
                <Box flex="1">
                  <MTableToolbar {...props} />
                </Box>
                <MaterialTableCustomSort
                  sort={sortQueryColor}
                  setSort={setSortQueryColor}
                  materialTableRef={tableRef}
                  columns={columns}
                />
              </Box>
            ),
          }}
          options={{
            actionsColumnIndex: -1,
            sorting: false,
            headerStyle: {
              zIndex: "unset",
            },
          }}
          data={(query) =>
            new Promise((resolve, reject) => {
              refetch({
                where: {
                  colorName_contains: query.search,
                },
                sort: sortQueryColor,
                start: query.page * query.pageSize,
                limit: query.pageSize,
              })
                .then((res) => {
                  const {
                    data: {
                      colorsConnection: { values, aggregate },
                    },
                  } = res;
                  const newData = values.map((item: any) => ({
                    id: item.id,
                    colorName: item.colorName,
                  }));
                  resolve({
                    data: newData,
                    page: query.page,
                    totalCount: aggregate.totalCount,
                  });
                })
                .catch((err) => console.log(err));
            })
          }
        />
      </div>
    </>
  );
};

export default ViewColors;
